import {useTranslation} from "react-i18next";
import rygLogo from "../../../assets/images/ryg-logo03.png";
import {BaseBreadcrumb} from "../../../components/BaseBreadcrumb";
import classes from "./DeleteAccount.module.css";

const DeleteAccount = () => {
  const {t} = useTranslation();

  return (
    <>
      <BaseBreadcrumb items={[{label: t("breadcrumbHome"), path: "/"}, {label: t("breadcrumbDeleteAccount")}]} />
      <div className={classes.logoRyg}>
        <img
          src={rygLogo}
          alt="Ryg Logo"
        />
      </div>
      <div className={classes.tosContainer}>
        <h2>{t("deleteAccountTitle")}:</h2>
        <p>
          {t("deleteAccountContent")}
          <a href="mailto:soporte@aprietaygana.com?subject=Solicitud%20de%20eliminación%20de%20cuenta">
            soporte@aprietaygana.com
          </a>
          {t("deleteAccountInfo")}
          <p>{t("deleteAccountInfo2")}</p>
        </p>
      </div>
    </>
  );
};

export default DeleteAccount;
